import React from 'react';
import CustomAddPage from 'components/custom-pages/CustomAddPage';

const Add = ({ data, handleClick }) => {
  const initialValues = {
    make: data?.make || '',
    makeName: data?.makeName || '',
    makeImg: data?.makeImg || '',
  };

  const inputFields = [
    {
      name: 'make',
      label: 'Vehicle Make Code',
      type: 'text',
      required: true,
    },
    {
      name: 'makeName',
      label: 'Vehicle Make Name',
      type: 'text',
      required: true,
    },
    {
      name: 'makeImg',
      label: 'Vehicle Make Image',
      type: 'file',
      url: data?.makeImg || '',
      limit: 1,
      multiple: false
    },
  ];

  return (
    <CustomAddPage
      pageTitle={data ? 'Update Vehicle Make' : 'Add Vehicle Make'}
      url={'vehicle-make-master'}
      action={!data ? 'create' : 'update'}
      updateId={data?._id}
      queryKey="vehicle-make-master"
      inputFields={inputFields}
      data={initialValues}
      handleClick={handleClick}
    />
  );
};

export default Add;
